import { Field } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { Loader, SelectField } from 'iqvia-shared/components';
import { secondaryOrange } from 'apollo-react-next/colors';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import React, { useEffect } from 'react';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

import { ConsentId, HCO, HCP } from '../../../../Shared/constants';
import { findObject } from './PathObjects';
import { validateEvent } from '../../../../Shared/Forms/FormValidation';
import ObjectField from './PathObjectFields';

const styles = {
  objectField: {
    ' & label + div > div > div': {
      minHeight: 22,
      lineHeight: '22px',
    },
  },
  warningIcon: {
    color: secondaryOrange[500],
    marginRight: '5px',
  },
  warningMessage: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
    fontWeight: 'normal',
    fontSize: 'small',
    paddingTop: '15px',
  },
};

export const PathObjectsComponent = ({
  intl,
  objects,
  item,
  index,
  setFormValueDispatch,
  setPathObjectDispatch,
  fetchObjectFieldsDispatch,
  readonlyForm,
  culture,
  currentMID,
  classes,
  isHCOEnabled,
  isLoadingDecisionSplitObjectFields,
  setPathContactTypeFieldDispatch,
  isHCO,
}) => {
  const objectsOptions = isHCO
    ? objects.filter(x => x.id === ConsentId).map(x => ({ value: x.id, label: x.name }))
    : objects.map(x => ({ value: x.id, label: x.name }));

  const contactTypeOptions = [{ value: HCP, label: HCP }, { value: HCO, label: HCO }];
  const obj = findObject(objects, item);

  const handleChangeObject = value => {
    const obj = objects.find(x => x.id === value);
    if (obj) {
      setPathObjectDispatch(index, obj.id);
      if (!obj.fields) {
        fetchObjectFieldsDispatch(obj.id, culture, currentMID);
      }
    }
  };

  useEffect(
    () => {
      if (!obj.fields && culture && currentMID > 0) {
        fetchObjectFieldsDispatch(obj.id, culture, currentMID);
      }
    },
    [culture, currentMID]
  );
  return (
    <React.Fragment>
      <Grid container spacing={8}>
        {isHCOEnabled && (
          <Grid item xs={6}>
            <Field
              name={`${item.arguments.branchResult}_contactType`}
              className={classes.objectField}
              component={SelectField}
              items={contactTypeOptions}
              disabled
              label={intl.formatMessage({
                id: 'journeyBuilder.decisionSplit_contactType',
              })}
            />
          </Grid>
        )}
        <Grid item xs={6}>
          <Field
            name={`${item.arguments.branchResult}_object`}
            className={classes.objectField}
            component={SelectField}
            items={objectsOptions}
            disabled={readonlyForm || objectsOptions.length < 2}
            label={intl.formatMessage({
              id: 'journeyBuilder.decisionSplit_object',
            })}
            validate={[validateEvent]}
            onChange={(_, value) => handleChangeObject(value)}
          />
        </Grid>
        {isLoadingDecisionSplitObjectFields && <Loader />}
        {obj.fields &&
          //TODO: OCEMCM-22248 - currently to hide and show RSVP Status dropdown in CDN UI, below if condition has hardcoded value
          //This shall be removed by common logic later.
          //LOADING TEST
          obj.fields.map(field => {
            if (
              field.name === 'RSVP Status' &&
              item &&
              item.metaData &&
              item.metaData.fieldValues &&
              item.metaData.fieldValues['Participation Metrics'] &&
              item.metaData.fieldValues['Participation Metrics'] !== 'RSVP STATUS'
            ) {
              item.metaData.fieldValues[field.name] = null;
              return null;
            }
            return (
              <Grid item key={`${obj.id}${field.name}`} xs={6}>
                <ObjectField
                  field={field}
                  item={item}
                  index={index}
                  readonlyForm={readonlyForm}
                  fields={obj.fields}
                  culture={culture}
                  currentMID={currentMID}
                  objId={obj.id}
                />
              </Grid>
            );
          })}
      </Grid>
      {isHCO &&
        isHCOEnabled && (
          <span className={classes.warningMessage}>
            <WarningRoundedIcon id="unsupportedHCOWarnIcon" className={classes.warningIcon} />
            <FormattedMessage id="formValidation_HCOValidation" />
          </span>
        )}
    </React.Fragment>
  );
};

PathObjectsComponent.displayName = 'PathObjectsComponent';
export default withStyles(styles, { name: 'PathObjectsComponent' })(PathObjectsComponent);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectsComponent.js